import { render, staticRenderFns } from "./viewer.vue?vue&type=template&id=b6b5b9ec&scoped=true&"
import script from "./viewer.vue?vue&type=script&lang=js&"
export * from "./viewer.vue?vue&type=script&lang=js&"
import style0 from "./viewer.vue?vue&type=style&index=0&id=b6b5b9ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b5b9ec",
  null
  
)

export default component.exports